import { baseAssets, darkModeBaseAssets, ThemeAssets } from './assets'

export const auroraAssets: ThemeAssets = {
  ...baseAssets,
}

export const auroraDarkModeAssets: ThemeAssets = {
  ...darkModeBaseAssets,
}
